import React from 'react'
import PropTypes from 'prop-types'
import styles from './SideOpenedField.module.scss'

/**
 * Props:
 * - label: string (field name)
 * - value: string or node (field value)
 * - onAction: function (optional click handler for action button)
 * - actionLabel: string (optional button text)
 */
export const SideOpenedField = ({
	position = 'middle',
	label = '라벨',
	value = '',
	onAction = null,
	actionLabel = '',
}) => {
	return (
		<div
			className={`${styles.fieldRow}${
				position === 'middle' ? ` ${styles['fieldRowmiddle']}` : ''
			}`}>
			<div className={styles.label}>{label}</div>
			<div className={styles.valueContainer}>
				{value && <div className={styles.value}>{value}</div>}
				{onAction && actionLabel && (
					<button type="button" className={styles.actionButton} onClick={onAction}>
						{actionLabel}
					</button>
				)}
			</div>
		</div>
	)
}

SideOpenedField.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	onAction: PropTypes.func,
	actionLabel: PropTypes.string,
}
